// C:\Ava_Local\Ava_API\avaai_dashboard\frontend\src\pages\education\AdditionPage.tsx
import React from "react";
import TutorPage from "./TutorPage";

export default function AdditionPage() {
  return <TutorPage initialTopic="Addition" lockTopic />;
}